import React from 'react';
import styled, { css } from 'styled-components';
import { submit } from '../firestore';

const URL =
  'https://firebasestorage.googleapis.com/v0/b/popshoplive-26f81.appspot.com/o/site%2Fvideo-promo.mp4?alt=media&token=0cf2974b-9129-4be4-bbc1-0e1b0ba7cfda';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const Title = styled.img.attrs({
  src: require('./images/buy-and-sell-with-li@3x.png')
})`
  margin: 100px auto 60px auto;
  width: 348px;
  height: 81px;
  display: flex;
`;

const VideoContainer = styled.div`
  max-width: 1000px;
  margin: 0 50px 50px 50px;
`;

const Input = styled.input<{ isInvalid?: boolean }>`
  background: none;
  outline: none;
  border: none;
  border-bottom: 3px solid #0effca;
  font-size: 20px;
  line-height: 26px;
  height: 46px;
  text-align: center;
  margin: 0 20px 30px 20px;
  color: #4a4a4a;
  ::placeholder {
    color: #4a4a4a;
  }
  ${props =>
    props.isInvalid &&
    css`
      border-bottom: 2px solid #9f3a38;
      color: #9f3a38;
      ::placeholder {
        color: #9f3a38;
      }
      :focus {
        border-bottom: 2px solid #9f3a38;
      }
    `}
`;

interface VideoPageState {
  isSubmitting: boolean;
  isInvalid: boolean;
  isVerified: boolean;
  code: string;
  placeholder: string;
}

class VideoPage extends React.Component<{}, VideoPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isSubmitting: false,
      isInvalid: false,
      isVerified: false,
      code: '',
      placeholder: 'Enter Code'
    };
  }

  public componentDidMount() {
    document.body.className = 'blue-background';
  }

  public handleSubmit = async () => {
    const { code } = this.state;
    if (code) {
      this.setState({ isSubmitting: true });
      try {
        const result = await submit(code);
        if (result === 'success') {
          this.setState({ isVerified: true });
        } else {
          this.setState({
            isSubmitting: false,
            isInvalid: true,
            code: '',
            placeholder: 'Invalid Code'
          });
        }
      } catch (error) {
        this.setState({
          isSubmitting: false,
          isInvalid: true,
          code: '',
          placeholder: 'Invalid Code'
        });
      }
    } else {
      this.setState({ isInvalid: true, code: '', placeholder: 'Enter Code' });
    }
  };

  public render() {
    const {
      isVerified,
      isSubmitting,
      isInvalid,
      code,
      placeholder
    } = this.state;

    if (isVerified) {
      return (
        <Container>
          <Title />
          <VideoContainer>
            <video
              loop={true}
              autoPlay={true}
              controls={true}
              preload="yes"
              width="100%"
              height="100%"
              src={URL}
            />
          </VideoContainer>
        </Container>
      );
    } else {
      return (
        <div className="container">
          <div className="welcome-container">
            <div className="welcome-title">Welcome to Popshop Live!</div>
            <div className="welcome-description">
              If you were invited here with a code, please enter it below:
            </div>
            <Input
              placeholder={placeholder}
              isInvalid={isInvalid}
              disabled={isSubmitting}
              value={code}
              onKeyDown={async event => {
                if (event.keyCode === 13) {
                  await this.handleSubmit();
                }
              }}
              onChange={event => {
                this.setState({
                  code: event.target.value,
                  isInvalid: false,
                  placeholder: 'Enter Code'
                });
              }}
            />
            <button
              className="submit-btn"
              disabled={isSubmitting}
              onClick={this.handleSubmit}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      );
    }
  }
}

export default VideoPage;
